import { State } from 'redux/utils/List'

export default State({}, {
    isSortable: false,
    isFilterable: false
})